import { Directive, Input, HostBinding, HostListener } from '@angular/core';

import { NavController } from '@ionic/angular';
import { AccountService } from 'src/app/shared/services/account.service';

@Directive({
  selector: '[appViewOtherUserProfile]',
})
export class ViewOtherUserProfileDirective {
  // user id for profile
  @Input() userId;

  constructor(
    private accountService: AccountService,
    private navCtrl: NavController,
  ) {}

  /**
   * This is used to hide selector if current user is not consumer
   *
   * @memberof ViewOtherUserProfileDirective
   */
  @HostBinding('style.display') isConsumer = this.accountService.userIs('consumer') ? 'block' : 'none';

  /**
   * Check if user id exist then redirect to view  carer profile
   *
   */
  @HostListener('click') onClick() {
    if (Object.keys(this).includes('userId')) {
      this.viewCarerProfile();
    }
  }

  /**
   * Navigate to carer profile
   *
   */
  viewCarerProfile() {
    this.navCtrl.navigateForward(`/search/view/${this.userId}`);
  }
}
